module.exports = __webpack_public_path__ + "8b7631b0aa7dcdcc1b168a9dd3f41841.jpg";